<template>
  <section>
    <div class="breadcrumb">
      <router-link :to="route">
        <i class="icon-ic_arrow_left_blue" /> <h6>{{ title }}</h6>
      </router-link>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    title: {
      type: String,
      required: true
    },
    route: {
      type: String,
      required: true
    }
  },
  data () {
    return {

    }
  }

}
</script>

<style lang="scss" scoped>
@import "~@/assets/stylesheets/styleguide";

.breadcrumb {
  display: inline-flex;
  margin-top: 0;

  a {
    padding-left: 0;
    padding-right: 0;
  }
}

h6 {
  color:$light-blue;
  color: var(--light-blue);
  margin-left: 1rem;
  font-size: 0.875rem;
  font-weight: 500;
}

</style>
